class NgResolutionDirective {
    static $inject = ['$q'];

    constructor($q) {
        'ngInject';
        this.$q = $q;
        this.restrict = 'A';
        this.require = 'ngModel';
        this.scope = false;
    }

    compile() {
        return this.link.bind(this);
    }

    link(scope, element, attrs, ngModel) {
        const [width, height] = attrs.ngResolution.split('x').map(Number);
        if (window.FileReader) {
            ngModel.$asyncValidators.resolution = (modelValue, viewValue) => {
                const value = modelValue || viewValue;
                const deferred = this.$q.defer();
                if (value instanceof File) {
                    const reader = new FileReader();
                    reader.onload = () => {
                        const image = new Image();
                        image.onload = function () {
                            if (image.width === width && image.height === height) {
                                deferred.resolve();
                            } else {
                                deferred.reject();
                            }
                        };
                        image.src = reader.result;
                    };
                    reader.readAsDataURL(value);
                }
                return deferred.promise;
            };
        }
    }

    static factory($q) {
        'ngInject';
        return new NgResolutionDirective($q);
    }
}

// Explicit DI annotation for factory used in angular.directive registration
NgResolutionDirective.factory.$inject = ['$q'];

export default NgResolutionDirective.factory;
